<template>
  <div>
    <div
      class="kqf-card mg10 pd10 mt20"
      v-loading="loading"
      style="min-width: 1100px"
    >
      <el-table border :data="datas.list" height="calc(100vh - 325px)">
        <el-table-column prop="package_id" label="ID" width="120">
        </el-table-column>
        <el-table-column prop="title" label="标题"> </el-table-column>
        <el-table-column prop="money" label="充值金额" width="120">
        </el-table-column>
        <el-table-column prop="give_money" label="赠送金额" width="120">
        </el-table-column>
        <el-table-column prop="product_id" label="虚拟支付道具ID" width="160">
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="120">
        </el-table-column>
        <el-table-column prop="sell_num" label="成功卖出次数" width="120">
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="170">
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" width="170">
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="editinfo(scope.row)"
              icon="el-icon-edit"
              type="primary"
              style="margin-right: 10px"
              >编辑</el-button
            >
            <el-popconfirm title="确定删除吗？" @confirm="deletes(scope.row)">
              <el-button
                icon="el-icon-delete"
                type="danger"
                slot="reference"
                size="mini"
                >删除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <div class="flex space mt10">
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="addtag()"
            >添加</el-button
          >
        </div>
        <div>
          <el-pagination
            @current-change="getList"
            background
            :page-size="datas.limit"
            layout="total, prev, pager, next"
            :total="datas.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!--编辑-->
    <el-dialog title="编辑" :visible.sync="editdialog" width="600px">
      <el-form label-width="130px" size="small" v-loading="editloading">
        <el-form-item label="标题：" required>
          <el-input v-model="editdata.title" style="width: 220px" />
        </el-form-item>
        <el-form-item label="充值金额：" required>
          <el-input v-model="editdata.money" style="width: 220px" />
        </el-form-item>
        <el-form-item label="赠送金额：" required>
          <el-input v-model="editdata.give_money" style="width: 220px" />
        </el-form-item>
        <el-form-item label="虚拟支付道具ID：">
          <el-input
            v-model="editdata.product_id"
            style="width: 220px"
            placeholder="微信虚拟支付道具 productId"
          />
        </el-form-item>
        <el-form-item label="排序：" required>
          <el-input
            type="number"
            v-model="editdata.sort"
            style="width: 220px"
            min="0"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="edit()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--添加-->
    <el-dialog title="添加" :visible.sync="adddialog" width="600px">
      <el-form label-width="130px" size="small" v-loading="addloading">
        <el-form-item label="标题：" required>
          <el-input v-model="adddata.title" style="width: 220px" />
        </el-form-item>
        <el-form-item label="充值金额：" required>
          <el-input v-model="adddata.money" style="width: 220px" />
        </el-form-item>
        <el-form-item label="赠送金额：" required>
          <el-input v-model="adddata.give_money" style="width: 220px" />
        </el-form-item>
        <el-form-item label="虚拟支付道具ID：">
          <el-input
            v-model="adddata.product_id"
            style="width: 220px"
            placeholder="微信虚拟支付道具 productId"
          />
        </el-form-item>
        <el-form-item label="排序：" required>
          <el-input
            type="number"
            v-model="adddata.sort"
            style="width: 220px"
            min="0"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="add()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  getLists,
  setadd,
  setedit,
  setdelete
} from "../../request/api/rechargePackage";
export default {
  data() {
    return {
      //列表信息
      loading: false,
      search: this.getSearch(),
      datas: [],
      //编辑信息
      editloading: false,
      editdialog: false,
      editdata: {
        package_id: 0,
        title: "",
        sort: "",
        money: "",
        give_money: "",
        product_id: ""
      },
      //添加信息
      adddialog: false,
      addloading: false,
      adddata: {
        title: "",
        sort: "",
        money: "",
        give_money: "",
        product_id: ""
      },
      page: 1,
      limit: 1
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //搜索
    getSearch() {
      return {
        page: 1
      };
    },
    //表格重载
    refresh() {
      this.search = this.getSearch();
      this.getList(1);
    },
    //列表
    getList(page) {
      this.search.page = page;
      this.loading = true;
      getLists({
        page: page
      })
        .then(res => {
          this.loading = false;
          this.datas = res;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //编辑
    edit() {
      this.editloading = true;
      setedit({
        ...this.editdata
      })
        .then(() => {
          this.editdialog = false;
          this.$message.success("操作成功");
          this.editloading = false;
          this.getList(1);
          this.editloading = false;
        })
        .catch(() => {
          this.editloading = false;
        });
    },
    //编辑信息填入
    editinfo(row) {
      this.editdialog = true;
      this.editdata = Object.assign(this.editdata, row);
    },
    //添加弹窗显示
    addtag() {
      this.adddialog = true;
    },
    //添加
    add() {
      this.addloading = true;
      setadd({
        ...this.adddata
      })
        .then(() => {
          this.adddialog = false;
          this.$message.success("操作成功");
          this.addloading = false;
          this.getList(1);
          this.addloading = false;
        })
        .catch(() => {
          this.addloading = false;
        });
    },
    // 删除
    deletes(row) {
      this.loading = true;
      setdelete({ package_id: row.package_id })
        .then(() => {
          //最后一页无数据 向上翻页
          if (this.datas.list.length <= 1 && this.search.page > 1) {
            this.search.page -= 1;
          }
          this.getList(this.search.page);
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
